<h1 class="matp-page-title tw-mb-4">配送設定一覧</h1>
<mat-card class="matp-card tw-my-4">
  <app-shipment-list-table
    [shipmentList]="shipmentList"
    [loadingMasterData]="loadingMasterData"
    (created)="openShipmentEditDialog()"
    (updated)="openShipmentEditDialog($event)"
    (deleted)="deletedShipment($event)"
  >
  </app-shipment-list-table>
</mat-card>
